// TODO: Codes related to showing flag is commented because this view is currently wrong and asked to hide this view and keep code for future
import { memo, useCallback } from 'react';
import { useMap } from 'react-map-gl/mapbox';
import { useSearchParams } from 'react-router-dom';

import type { PickingInfo } from '@deck.gl/core';

import DeckGLOverlay from '@/components/map/train-marker/deckgl-overlay';
import useMapPinInteractivity from '@/hooks/map/use-map-pin-interactivity';
// import useGetRoutesDeviationMap from '@/hooks/use-get-routes-deviation-map';
import usePinnedItem from '@/hooks/use-pinned-item';
import useChainStore from '@/store/useChainStore';
import {
  SEARCH_PARAM_DRAWER,
  SEARCH_PARAM_INCIDENT_ID,
  SEARCH_PARAM_INCIDENTS,
  SEARCH_PARAM_ROUTES,
  SEARCH_PARAM_SHOW,
  SEARCH_PARAM_STATION_ID,
  SEARCH_PARAMS_ROUTE_ID,
} from '@/utils/constants/queries';
import { useDeckCursorHover } from '@/utils/helpers/train-simulation/use-deck-cursor-hover';
import { useRealtimeTrains } from '@/utils/helpers/train-simulation/use-realtime-trains';

const TrainMarker = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { current: mapRef } = useMap();
  const { pinnedItemId, pinnedItemType } = usePinnedItem();
  // const { activeJourneys } = useGetRoutesDeviationMap();
  const { addToLast } = useChainStore();

  const selectedRouteId = searchParams.get(SEARCH_PARAMS_ROUTE_ID);
  const selectedStationId = searchParams.get(SEARCH_PARAM_STATION_ID);
  const lockedJourneyId = pinnedItemId && pinnedItemType === 'route' ? pinnedItemId : null;

  const isTrainPinned = Boolean(lockedJourneyId);
  useMapPinInteractivity(isTrainPinned);

  const handleClick = useCallback(
    (info: PickingInfo) => {
      const trainId = info?.object?.id;

      if (!trainId) {
        return;
      }

      const shouldAddToLast = (selectedRouteId || selectedStationId) && selectedRouteId !== trainId;

      if (shouldAddToLast) {
        addToLast({
          [SEARCH_PARAMS_ROUTE_ID]: searchParams.get(SEARCH_PARAMS_ROUTE_ID),
          [SEARCH_PARAM_SHOW]: searchParams.get(SEARCH_PARAM_SHOW),
          [SEARCH_PARAM_STATION_ID]: searchParams.get(SEARCH_PARAM_STATION_ID),
        });
      }

      if (trainId) {
        const newSearchParams = new URLSearchParams(searchParams);
        newSearchParams.delete(SEARCH_PARAM_STATION_ID);
        newSearchParams.delete(SEARCH_PARAM_INCIDENT_ID);
        newSearchParams.delete(SEARCH_PARAM_INCIDENT_ID);
        newSearchParams.delete(SEARCH_PARAM_INCIDENTS);
        newSearchParams.delete(SEARCH_PARAM_DRAWER);
        newSearchParams.set(SEARCH_PARAMS_ROUTE_ID, trainId);
        newSearchParams.set(SEARCH_PARAM_SHOW, SEARCH_PARAM_ROUTES);

        setSearchParams(newSearchParams, { replace: true });

        return true;
      }
    },
    [searchParams]
  );

  // const flaggedTrainIds = useMemo(
  //   () =>
  //     activeJourneys?.reduce<string[]>((ids, { isFlagged, id }) => {
  //       if (isFlagged) {
  //         ids.push(id);
  //       }
  //
  //       return ids;
  //     }, []) ?? [],
  //   [activeJourneys]
  // );

  const layers = useRealtimeTrains(mapRef, lockedJourneyId /*, flaggedTrainIds*/);
  const handleHover = useDeckCursorHover(mapRef);

  return <DeckGLOverlay layers={layers} onClick={handleClick} onHover={handleHover} />;
};

export default memo(TrainMarker);
